import { loadCosmosAlert } from 'cookie-banner/styles'

import { HotmartAlert } from '../hotmart/HotmartAlert'

export class HotmartCoAlert extends HotmartAlert {
  override async loadCompanyStyle(): Promise<void> {
    await loadCosmosAlert()
    await require('./hotmart-co-tokens.css')
  }

  override afterRender(): void {
    const style = document.createElement('style')
    style.innerHTML = `
      :host {
        --primary: var(--hc-color-primary-700);
        --primary-dark: var(--hc-color-primary-400);
        --primary-darker: var(--hc-color-primary-600);
        --primary-lighter: var(--hc-color-neutral-300);
        --primary-lightest: var(--hc-color-neutral-200);
        --font-family: Poppins;
        --blue: var(--hc-color-primary-700);
      }
      a {
        color: var(--hc-color-neutral-1000);
      }
      a:hover {
        color: var(--hc-color-neutral-600);
      }
    `
    this.root.appendChild(style)
  }
}
